import styled from 'styled-components'

import { Typography } from '../Typography'

export const FormHelperText = styled(Typography).attrs({ size: '400-sm' })`
  margin-top: 4px;
  color: ${({ theme }) => theme.colors.error[150]};
`
